import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { useLinkTracking } from "./hooks/useLinkTracking/UseLinkTracking";
/* PLOP_INJECT_IMPORT */
import { NearOurNetworkPage } from "./pages/NearOurNetworkPage";
import { ReferenceMapsPage } from "./pages/ReferenceMapsPage";
import { ElectrictySupplyConfirmationPage } from "./pages/ElectrictySupplyConfirmationPage";
import { ElectricityCapacityChecksPage } from "./pages/ElectricityCapacityChecksPage";
import { HighLoadPermitsPage } from "./pages/HighLoadPermitsPage";
import { ArtworkOnVectorEquipmentPage } from "./pages/ArtworkOnVectorEquipmentPage";
import { CloseApproachConsentsPage } from "./pages/CloseApproachConsentsPage";
import { GasLandingPage } from "./pages/GasLandingPage";
import { ElectricityLandingPage } from "./pages/ElectricityLandingPage";
import { DistributedGenerationBigPage } from "./pages/DistributedGenerationBigPage";
import { DistributedGenerationSmallPage } from "./pages/DistributedGenerationSmallPage";
import { DistributedGenerationOverviewPage } from "./pages/DistributedGenerationOverviewPage";
import { TreeRelatedFaultsPage } from "./pages/TreeRelatedFaultsPage";
import { VectorElectricityChangesPage } from "./pages/VectorElectricityChangesPage";
import { TempElectricityRelocationPage } from "./pages/TempElectricityRelocationPage";
import { GasMainsRelocationPage } from "./pages/GasMainsRelocationPage";
import { GasOutagesPage } from "./pages/GasOutagesPage";
import { GraffitiPage } from "./pages/GraffitiPage";
import { GasDisconnectionPage } from "./pages/GasDisconnectionPage";
import { VectorEquipmentFaultsPage } from "./pages/VectorEquipmentFaultsPage";
import { UpgradesDowngradesPage } from "./pages/UpgradesDowngradesPage";
import { ElectricityChangesPage } from "./pages/ElectricityChangesPage";
import { ElectricityDisconnectionPage } from "./pages/ElectricityDisconnectionPage";
import { HotWaterOutagesPage } from "./pages/HotWaterOutagesPage";
import { TempServiceLineDisconnectionPage } from "./pages/TempServiceLineDisconnectionPage";
import { StreetlightFaultsPage } from "./pages/StreetlightFaultsPage";
import { PermanentElectricityDisconnectionPage } from "./pages/PermanentElectricityDisconnectionPage";
import { PowerOutagesPage } from "./pages/PowerOutagesPage";
import { HomePage } from "./pages/HomePage";
import { OutagesAndFaultsPage } from "./pages/OutagesAndFaultsPage";
import { NewComplexGasConnection } from "./pages/NewComplexGasConnection";
import { NewSimpleGasConnectionPage } from "./pages/NewSimpleGasConnectionPage";
import { NewGasConnectionPage } from "./pages/NewGasConnectionPage";
import { LiveningElectricityConnectionPage } from "./pages/LiveningElectricityConnectionPage";
import { BuildersTemporarySupplyPage } from "./pages/BuildersTemporarySupplyPage";
import { ComplexElectricityConnectionPage } from "./pages/ComplexElectricityConnectionPage";
import { ComponentTestPage } from "./pages/ComponentTestPage";
import { NewElectricityConnectionPage } from "./pages/NewElectricityConnectionPage";
import { SimpleElectricityConnectionPage } from "./pages/SimpleElectricityConnectionPage";
import withPageTracker from "./WithPageTracker";

const HOME_PAGE = "/";
/* PLOP_INJECT_URL_CONST */
const NEAR_OUR_NETWORK_PAGE = "/(personal|business|developers)/help-safety/near-our-network";
const REFERENCE_MAPS_PAGE = "/(personal|business|developers)/help-safety/near-our-network/reference-plans";
const ELECTRICTY_SUPPLY_CONFIRMATION_PAGE = "/(personal|business|developers)/electricity/confirmation-of-supply";
const ELECTRICITY_CAPACITY_CHECKS_PAGE = "/(personal|business|developers)/electricity/capacity-check";
const HIGH_LOAD_PERMITS_PAGE = "/(personal|business|developers)/help-safety/near-our-network/high-load-permit";
const ARTWORK_ON_VECTOR_EQUIPMENT_PAGE = "/(personal|business|developers)/help-safety/near-our-network/artwork-on-our-equipment";
const CLOSE_APPROACH_CONSENTS_PAGE = "/(personal|business|developers)/help-safety/near-our-network/close-approach-consents";
const GAS_LANDING_PAGE = "/(personal|business|developers)/gas";
const ELECTRICITY_LANDING_PAGE = "/(personal|business|developers)/electricity";
const DISTRIBUTED_GENERATION_BIG_PAGE = "/(personal|business|developers)/electricity/distributed-generation/more-than-10kw";
const DISTRIBUTED_GENERATION_SMALL_PAGE = "/(personal|business|developers)/electricity/distributed-generation/10kw-or-less";
const DISTRIBUTED_GENERATION_OVERVIEW_PAGE = "/(personal|business|developers)/electricity/distributed-generation";
const TREE_RELATED_FAULTS_PAGE = "/(personal|business|developers)/outages-faults/trees";
const VECTOR_ELECTRICITY_CHANGES_PAGE = "/(personal|business|developers)/electricity/connection-change/vector-equipment";
const TEMP_ELECTRICITY_RELOCATION_PAGE = "/(personal|business|developers)/help-safety/near-our-network/temp-changes-vector";
const GAS_MAINS_RELOCATION_PAGE = "/(personal|business|developers)/gas/gas-main-relocation";
const GAS_OUTAGES_PAGE = "/(personal|business|developers)/outages-faults/gas";
const GRAFFITI_PAGE = "/(personal|business|developers)/outages-faults/graffiti";
const GAS_DISCONNECTION_PAGE = "/(personal|business|developers)/gas/disconnection";
const VECTOR_EQUIPMENT_FAULTS_PAGE = "/(personal|business|developers)/outages-faults/vector-equipment";
const UPGRADES_DOWNGRADES_PAGE = "/(personal|business|developers)/electricity/connection-change/upgrades-downgrades";
const ELECTRICITY_CHANGES_PAGE = "/(personal|business|developers)/electricity/connection-change";
const ELECTRICITY_DISCONNECTION_PAGE = "/(personal|business|developers)/electricity/disconnection";
const HOT_WATER_OUTAGES_PAGE = "/(personal|business|developers)/outages-faults/hot-water";
const TEMP_SERVICE_LINE_DISCONNECTION_PAGE =
  "/(personal|business|developers)/help-safety/near-our-network/temporary-service-line-disconnection";
const STREETLIGHT_FAULTS_PAGE = "/(personal|business|developers)/outages-faults/streetlights";
const PERMANENT_ELECTRICITY_DISCONNECTION_PAGE = "/(personal|business|developers)/electricity/disconnection/permanent";
const POWER_OUTAGES_PAGE = "/(personal|business|developers)/outages-faults/power-outages";
const OUTAGES_AND_FAULTS_PAGE = "/(personal|business|developers)/outages-faults";
const NEW_COMPLEX_GAS_CONNECTION = "/(personal|business|developers)/gas/new-connection/complex";
const NEW_SIMPLE_GAS_CONNECTION_PAGE = "/(personal|business|developers)/gas/new-connection/simple";
const NEW_GAS_CONNECTION_PAGE = "/(personal|business|developers)/gas/new-connection";
const LIVENING_ELECTRICITY_CONNECTION_PAGE = "/(personal|business|developers)/electricity/new-connection/livening";
const BUILDERS_TEMPORARY_SUPPLY_PAGE = "/(personal|business|developers)/electricity/new-connection/builders-temporary-supply";
const COMPLEX_ELECTRICITY_CONNECTION_PAGE = "/(personal|business|developers)/electricity/new-connection/complex";
const TEST_PAGE = "/component/test/page";
const SIMPLE_ELECTRICITY_CONN_PAGE = "/(personal|business|developers)/electricity/new-connection/simple";
const NEW_ELECTRICITY_CONNECTION_PAGE = "/(personal|business|developers)/electricity/new-connection";

const createRoute = (path: string, page: React.ComponentType<any>) => <Route exact path={path} component={withPageTracker(page)} />;

function App() {
  useLinkTracking();
  return (
    <Router>
      <Switch>
        <Route exact path={HOME_PAGE}>
          <HomePage />
        </Route>
        {/* PLOP_INJECT_CREATE_ROUTE */}
        {createRoute(NEAR_OUR_NETWORK_PAGE, NearOurNetworkPage)}
        {createRoute(REFERENCE_MAPS_PAGE, ReferenceMapsPage)}
        {createRoute(ELECTRICTY_SUPPLY_CONFIRMATION_PAGE, ElectrictySupplyConfirmationPage)}
        {createRoute(ELECTRICITY_CAPACITY_CHECKS_PAGE, ElectricityCapacityChecksPage)}
        {createRoute(HIGH_LOAD_PERMITS_PAGE, HighLoadPermitsPage)}
        {createRoute(ARTWORK_ON_VECTOR_EQUIPMENT_PAGE, ArtworkOnVectorEquipmentPage)}
        {createRoute(CLOSE_APPROACH_CONSENTS_PAGE, CloseApproachConsentsPage)}
        {createRoute(GAS_LANDING_PAGE, GasLandingPage)}
        {createRoute(ELECTRICITY_LANDING_PAGE, ElectricityLandingPage)}
        {createRoute(DISTRIBUTED_GENERATION_BIG_PAGE, DistributedGenerationBigPage)}
        {createRoute(DISTRIBUTED_GENERATION_SMALL_PAGE, DistributedGenerationSmallPage)}
        {createRoute(DISTRIBUTED_GENERATION_OVERVIEW_PAGE, DistributedGenerationOverviewPage)}
        {createRoute(TREE_RELATED_FAULTS_PAGE, TreeRelatedFaultsPage)}
        {createRoute(VECTOR_ELECTRICITY_CHANGES_PAGE, VectorElectricityChangesPage)}
        {createRoute(TEMP_ELECTRICITY_RELOCATION_PAGE, TempElectricityRelocationPage)}
        {createRoute(GAS_MAINS_RELOCATION_PAGE, GasMainsRelocationPage)}
        {createRoute(GAS_OUTAGES_PAGE, GasOutagesPage)}
        {createRoute(GRAFFITI_PAGE, GraffitiPage)}
        {createRoute(GAS_DISCONNECTION_PAGE, GasDisconnectionPage)}
        {createRoute(VECTOR_EQUIPMENT_FAULTS_PAGE, VectorEquipmentFaultsPage)}
        {createRoute(UPGRADES_DOWNGRADES_PAGE, UpgradesDowngradesPage)}
        {createRoute(ELECTRICITY_CHANGES_PAGE, ElectricityChangesPage)}
        {createRoute(ELECTRICITY_DISCONNECTION_PAGE, ElectricityDisconnectionPage)}
        {createRoute(HOT_WATER_OUTAGES_PAGE, HotWaterOutagesPage)}
        {createRoute(TEMP_SERVICE_LINE_DISCONNECTION_PAGE, TempServiceLineDisconnectionPage)}
        {createRoute(STREETLIGHT_FAULTS_PAGE, StreetlightFaultsPage)}
        {createRoute(PERMANENT_ELECTRICITY_DISCONNECTION_PAGE, PermanentElectricityDisconnectionPage)}
        {createRoute(POWER_OUTAGES_PAGE, PowerOutagesPage)}
        {createRoute(OUTAGES_AND_FAULTS_PAGE, OutagesAndFaultsPage)}
        {createRoute(NEW_COMPLEX_GAS_CONNECTION, NewComplexGasConnection)}
        {createRoute(NEW_GAS_CONNECTION_PAGE, NewGasConnectionPage)}
        {createRoute(BUILDERS_TEMPORARY_SUPPLY_PAGE, BuildersTemporarySupplyPage)}
        {createRoute(NEW_ELECTRICITY_CONNECTION_PAGE, NewElectricityConnectionPage)}
        {createRoute(SIMPLE_ELECTRICITY_CONN_PAGE, SimpleElectricityConnectionPage)}
        {createRoute(COMPLEX_ELECTRICITY_CONNECTION_PAGE, ComplexElectricityConnectionPage)}
        {createRoute(LIVENING_ELECTRICITY_CONNECTION_PAGE, LiveningElectricityConnectionPage)}
        {createRoute(NEW_SIMPLE_GAS_CONNECTION_PAGE, NewSimpleGasConnectionPage)}
        {createRoute(TEST_PAGE, ComponentTestPage)}
        <Redirect to={HOME_PAGE} />
      </Switch>
    </Router>
  );
}

export default App;
